import { Link } from "react-router-dom";
import { PublicShell } from "@/components/PublicShell";
import { LeadForm } from "@/components/LeadForm";
import { Seo } from "@/components/Seo";
import { Check } from "lucide-react";

const POINTS = [
  "See your own risk posture quantified in £ (P10–P90 loss curves)",
  "Walk a live, DORA-aligned tenant with real registers and feeds",
  "Watch the closed-loop reaction — a live incident re-pricing posture in seconds",
  "Get your questions answered by the accountable AI copilot",
];

export default function BookDemo() {
  return (
    <PublicShell active="/demo">
      <Seo title="Book an ERIO Demo — EKSELENS" path="/demo"
        description="Book a live walkthrough of the ERIO risk decision-intelligence platform." />
      <section className="mx-auto grid max-w-6xl gap-12 px-6 py-16 lg:grid-cols-2 lg:items-start">
        <div>
          <span className="text-xs font-semibold uppercase tracking-wider text-ek-purple">Book a demo</span>
          <h1 className="mt-3 text-4xl font-semibold tracking-tight sm:text-5xl">See ERIO come alive on real data.</h1>
          <p className="mt-4 text-base text-ek-ink/70">
            A guided, 30-minute walkthrough of the live platform — tailored to your sector and your biggest
            risk questions. No slideware.
          </p>
          <ul className="mt-8 space-y-3.5">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm text-ek-ink/80">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-ek-purple/10 text-ek-purple">
                  <Check size={13} />
                </span>
                {p}
              </li>
            ))}
          </ul>
          <p className="mt-8 text-sm text-ek-ink/70">
            Prefer to read first? <Link to="/brief" className="font-semibold text-ek-purple hover:underline">Get the executive brief →</Link>
          </p>
        </div>
        <div className="rounded-2xl border border-black/5 bg-white p-7 shadow-sm lg:p-8">
          <h2 className="text-lg font-semibold">Request your walkthrough</h2>
          <p className="mt-1 mb-5 text-sm text-ek-ink/70">Tell us a little about you and we'll be in touch to arrange a time.</p>
          <LeadForm kind="demo" source="book-demo-page"
            messagePlaceholder="What would you most like to see in the demo?" />
        </div>
      </section>
    </PublicShell>
  );
}
